import { AxiosResponse } from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { ApplicationState } from '../..';
import api, { errorHandler } from '../../../services/api';
import { requestHeaders } from '../../../utils/apiHelper';
import {
  Config,
  Data,
  filterParamsHandle,
  sorterParamsHandle,
} from '../../../utils/newTableHelper';
import { refreshRequest } from '../auth/actions';
import {
  failureDetail,
  failureSteps,
  loadDetail,
  loadFailure,
  loadRequest,
  loadSteps,
  loadSuccess,
  successDetail,
  successSteps,
} from './actions';
import { Step } from './types';

export function* loadOrdersDetail({ payload }: ReturnType<typeof loadRequest>) {
  try {
    const state: ApplicationState = yield select();
    const headers = requestHeaders(state.auth.token);
    const config: AxiosResponse<Config> = yield call(api.get, `order/detail/item/config`, {
      headers: headers,
    });
    const response: AxiosResponse<{
      content: Data[];
      numberOfElements: number;
      size: number;
      number: number;
    }> = yield call(
      api.post,
      `order/detail/${payload.id}/item`,
      {
        page: (payload.pagination?.current || 1) - 1,
        size: payload.pagination?.pageSize || 12,
        filters: filterParamsHandle(payload.filter),
        sort: sorterParamsHandle(payload.sorter),
      },
      { headers: headers }
    );
    yield put(
      loadSuccess(
        {
          total: response.data.numberOfElements,
          current: response.data.number + 1,
          pageSize: response.data.size,
        },
        response.data.content,
        config.data
      )
    );
  } catch (err: any) {
    yield put(err.response.status !== 401 ? loadFailure(errorHandler(err)) : refreshRequest());
  }
}

export function* requestOrderDetail({ payload }: ReturnType<typeof loadDetail>) {
  try {
    const state: ApplicationState = yield select();
    const headers = requestHeaders(state.auth.token);
    const config: AxiosResponse<Config> = yield call(api.get, `order/detail/config`, {
      headers: headers,
    });
    const response: AxiosResponse<Data> = yield call(api.get, `order/detail/${payload.id}`, {
      headers: headers,
    });
    yield put(successDetail(response.data.fields, config.data));
  } catch (err: any) {
    yield put(err.response.status !== 401 ? failureDetail(errorHandler(err)) : refreshRequest());
  }
}

export function* requestSteps({ payload }: ReturnType<typeof loadSteps>) {
  try {
    const state: ApplicationState = yield select();
    const headers = requestHeaders(state.auth.token);
    const response: AxiosResponse<Step[]> = yield call(api.get, `order/${payload.id}/status`, {
      headers: headers,
    });
    yield put(
      successSteps(
        response.data.sort((a: Step, b: Step) => {
          if (a.order < b.order) {
            return -1;
          }
          if (a.order > b.order) {
            return 1;
          }
          return 0;
        })
      )
    );
  } catch (err: any) {
    yield put(err.response.status !== 401 ? failureSteps(errorHandler(err)) : refreshRequest());
  }
}
